import { EntityBase } from "../../../../projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class ReviewReportModel extends EntityBase {
  public ReportKey: string;
  public Title: string;
  public DataValue: string;
  constructor() {
    super();
    this.ReportKey = "";
    this.ReportKey = "";
    this.DataValue = "";
  }
}
